import type { QueryClient } from '@tanstack/react-query';
import type { JavascriptRequestDataModel } from 'autogen/swagger/all';
import { JavascriptRequestDataModelQueryKey } from 'autogen/swagger/all/hooks';

export type RequiredQueryClientData = {
    javascriptRequestDataModel: JavascriptRequestDataModel;
};

export default function prepareQueryClient(queryClient: QueryClient, clientData: RequiredQueryClientData) {
    // add all the neccessary data that needs to be set on the queryClient.
    queryClient.setQueryData([JavascriptRequestDataModelQueryKey], clientData.javascriptRequestDataModel);

    return queryClient;
}
